// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import removeEmptyFields from '../utils/removeEmptyFields';

export const getIdentifiers = (inAuthId) => (inAuthId ? [{
  system: 'INAUTH_TRANSACTION_IDENTIFIER',
  id: inAuthId,
}] : undefined);

export const getDateTime = () => {
  const timeFormat = moment(new Date()).utc().format('YYYYMMDDTHHmmss.SSS');
  return `${timeFormat} GMT`;
};

export const getProductWithLocale = (product, plasticColor = 'platinum') => {
  const {
    productShortName,
    businessCodes: { sourcecode, pct },
    productName,
    accountToken,
  } = product;
  return {
    name: productShortName,
    descriptiveName: productName,
    sourcecode,
    selectedAccountToken: accountToken,
    locale: 'de-DE',
    pct: productShortName === 'platinum' ? pct[plasticColor] : pct[productShortName],
  };
};

export const getNames = (firstName, middleName, lastName) => [removeEmptyFields({
  type: 'PRIMARY',
  language: 'ES',
  firstName,
  lastName,
  middleName,
})];

export const getIdentities = (identification, curp) => {
  const identities = [];

  if (curp) {
    identities.push({
      type: 'NATIONAL_ID',
      number: curp.toUpperCase(),
    });
  }

  return [
    {
      type: 'TAX_ID',
      number: identification?.replace(/[ -]/g, ''),
    },
    ...identities,
  ];
};

export const getCompanies = ({ profession, occupation, industry }) => {
  const industriesObject = industry ? {
    industries:
      [{
        type: 'PRIMARY',
        industry,
      }],
  } : {};

  return [{
    type: 'PRIMARY',
    employments: [
      {
        type: 'PRIMARY',
        status: profession,
        occupation,
      },
    ],
    ...industriesObject,
  }];
};
